import { Box, BoxProps, Text } from "@chakra-ui/react";
import { BlogInterface } from "../../constants/Blog";
import { useNavigate } from "react-router-dom";

interface Props extends BoxProps {
  data: BlogInterface | undefined;
}

const LatestPostHero = ({ data, ...rest }: Props) => {
  const navigate = useNavigate();

  const goToDetail = () => {
    navigate(`/blog/${data?.slug}`);
  };

  return (
    <Box
      className={"ratio-16-9"}
      w={"100%"}
      h={"100%"}
      maxH={"424px"}
      px={[5, null, null, 12]}
      py={"40px"}
      rounded={"8px"}
      backgroundImage={
        data?.thumbnail
          ? `${process.env.REACT_APP_MEDIA_URL}${data?.thumbnail}`
          : ""
      }
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      display={"flex"}
      alignItems={"end"}
      cursor={"pointer"}
      onClick={goToDetail}
      {...rest}
    >
      <Box
        backdropFilter="auto"
        bg={"white.100"}
        backdropBlur="10px"
        w={"full"}
        rounded={"8px"}
        flex={"none"}
        p={{ base: "12px", sm: "16px", xl: "20px" }}
      >
        <Text textStyle={"h-xs-gray50"} textTransform={"uppercase"}>
          {data?.category_name}
        </Text>

        <Text
          textStyle={{ base: "h-base-white", xl: "h-xl-white" }}
          my={"4px"}
          lineHeight={{ base: "20px", xl: "32px" }}
        >
          {data?.title}
        </Text>

        <Text
          textStyle={"b-xs-white"}
          lineHeight={"14px"}
          noOfLines={{ base: 3, xl: 2 }}
          w={{ base: "100%", md: "80%", xl: "60%" }}
        >
          {data?.preview}
        </Text>
      </Box>
    </Box>
  );
};

export default LatestPostHero;
